export default "__VITE_ASSET__Bpf$vmEk__"